export default "__VITE_ASSET__BpGiOWAK__"